import { render, staticRenderFns } from "./BugReporter.vue?vue&type=template&id=5f4e5aaa&scoped=true"
import script from "./BugReporter.vue?vue&type=script&lang=js"
export * from "./BugReporter.vue?vue&type=script&lang=js"
import style0 from "./BugReporter.vue?vue&type=style&index=0&id=5f4e5aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4e5aaa",
  null
  
)

export default component.exports